import { api } from 'api';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_SERVICE_CATEGORIES } from './service-categories-constants';
import { getKzServiceCategoryList } from './service-categories-utils';
import { ServiceCategory } from './service-categories-types';

/**
 * Загрузка информации об outstore и instore услугах
 * @param store
 * @param regionCode
 * @returns {Promise<Measure>}
 */
export const getServiceCategories = (store: Store, regionCode: string) => {
  const { apiKey, orchestratorHost, useCredentials, requestID } = store.get();

  if (regionCode === KAZAKHSTAN) {
    return getKzServiceCategoryList();
  }

  return api.get<ServiceCategory[]>(
    'get-top-service-categories',
    { regionCode },
    {
      orchestratorHost,
      useCredentials,
      apiKey,
      requestID,
    }
  );
};

/**
 * Экшен загрузки информации об outstore и instore услугах
 * @param {Store} store
 * @returns {Promise<State>}
 */
export const loadServiceCategoriesAction = (store: Store) =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      useCredentials: process.env.USE_CREDENTIALS === '1',
      apiKey: process.env.API_KEY,
    });
    store.dispatch(FETCH_SERVICE_CATEGORIES.init, undefined);

    const unsub = store.on('@dispatch', state => {
      if (state.serviceCategories.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
